import { $mount } from '../../../js/dom-lifecycle';

$mount('#rejectReasonChoices').on('change', function () {
    $('#rejectReason').val($(this).val()).trigger('input');
});